export enum VehicleStatus
{
    Available = 0,
    
    OnIntermediateLocation = 1,
    
    InStorage = 2
}

export const VehicleStatusOptions = [
    {
        label: "core.vehicle_status.available",
        value: VehicleStatus.Available
    },
    {
        label: "core.vehicle_status.on_intermediate_location",
        value: VehicleStatus.OnIntermediateLocation
    },
    {
        label: "core.vehicle_status.in_storage",
        value: VehicleStatus.InStorage
    },
]
